"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSlice = exports.isSlice = exports.YachtSpecificationSlice = void 0;
var YachtSpecificationSlice;
(function (YachtSpecificationSlice) {
    YachtSpecificationSlice.keys = [
        "name",
        "priorName",
        "lengthMeters",
        "beamMeters",
        "draftMeters",
        "speedCruiseKPH",
        "speedMaxKPH",
        "fuelCruiseLPH",
        "fuelMaxLPH",
        "rangeCruiseKm",
        "rangeMaxKm",
        "engine",
        "hull",
        "stabilisers",
        "flagCountry",
        "yearLaunch",
        "yearRefit",
        "builder",
        "designer",
    ];
})(YachtSpecificationSlice || (exports.YachtSpecificationSlice = YachtSpecificationSlice = {}));
/** Type-guard for Slices by contentType. */
var isSlice = function (slice, contentType) {
    return slice.contentType === contentType;
};
exports.isSlice = isSlice;
/**
 * Returns a type-guard predicate suitable for use in `Array.filter()`.
 *
 * @example slices
 * 	  .filter(filterSlice('TEXT'))
 * 	  .forEach(slice => console.log(slice.markdown));
 */
var filterSlice = function (contentType) { return (function (slice) { return (0, exports.isSlice)(slice, contentType); }); };
exports.filterSlice = filterSlice;
